export interface ReleaseDownloads {
  installer: string; // Windows 安装包 (.exe)
  portable: string;  // Windows 绿色免安装包 (.zip)
  mac?: string;       // macOS 客户端 (.dmg)
}

export interface ReleaseItem {
  version: string;
  release_date: string;
  title: string;
  is_critical?: boolean;
  changelog: string[];
  download_url?: string;
  downloads?: ReleaseDownloads;
}

export const API_UPDATE_HISTORY_URL = 'https://emailkey.atlasslicer.com/api/update/history';

export const DEFAULT_RELEASES: ReleaseItem[] = [
  {
    version: '1.0.0',
    release_date: '2026-10-30',
    title: 'v1.0.0 官方正式版发布',
    is_critical: false,
    changelog: [
      'AtlasSlicer 官方首发正式版上线',
      '支持高性能精灵图装箱打包与 4合1 智能切图',
      '动效质检播放与多主流游戏引擎格式导出',
      '客户端设备授权与自动激活集成',
    ],
    download_url: 'https://atlasslicer.com/download',
    downloads: {
      installer: 'https://download.atlasslicer.com/1.0.0/AtlasSlicer_1.0.0_x64-setup.exe',
      portable: 'https://download.atlasslicer.com/1.0.0/AtlasSlicer_1.0.0_x64_Portable.zip',
      mac: 'https://download.atlasslicer.com/1.0.0/AtlasSlicer_1.0.0_aarch64.dmg',
    },
  },
];
